/**
 * Formats a number to string with the requested precision.
 *
 * @param number
 * @param decimals
 */
export function formatNumber(number, decimals = 0) {
    let isNegative = (number < 0);
    number = Math.abs(number);
    return (isNegative ? '-' : '') + number.toFixed(decimals).replace(/./g, function (c, i, a) {
        return i && c !== "." && ((a.length - i) % 3 === 0) ? ',' + c : c;
    });
}
